/* eslint max-len: off */
import React from 'react';
import {Icon} from '../createSvg';
import {IconProps} from '../types';

export const LpViews = (props: IconProps) => (
  <Icon {...props}>
    <path
      d="M14.0001 17.6251C15.3808 17.6251 16.5001 16.5058 16.5001 15.1251C16.5001 13.7443 15.3808 12.6251 14.0001 12.6251C12.6193 12.6251 11.5001 13.7443 11.5001 15.1251C11.5001 16.5058 12.6193 17.6251 14.0001 17.6251Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 4C2 2.34315 3.34315 1 5 1H17C18.6569 1 20 2.34315 20 4V12.125L22.4 13.925C22.7777 14.2083 23 14.6529 23 15.125C23 15.5971 22.7777 16.0417 22.4 16.325L20 18.125V20C20 21.6569 18.6569 23 17 23H5C3.34315 23 2 21.6569 2 20V4ZM10.4 12.2C12.5333 10.6 15.4667 10.6 17.6 12.2L21.5 15.125L17.6 18.05C15.4667 19.65 12.5333 19.65 10.4 18.05L6.5 15.125L10.4 12.2ZM6.5 6.25C6.5 5.83579 6.83579 5.5 7.25 5.5H14.75C15.1642 5.5 15.5 5.83579 15.5 6.25C15.5 6.66421 15.1642 7 14.75 7H7.25C6.83579 7 6.5 6.66421 6.5 6.25Z"
    />
  </Icon>
);
